import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import { Link } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
import "./bilanCompetence.scss"
export default function BilanCompetence() {
  const {setHeadband} = useContext(headbandContext)
  const {crumbs, setCrumbs} = useContext(crumbContext)
  useEffect(() => {
      setHeadband({
          title :  "Le bilan de compétence",
          icon : "picto_bilan_de_competence.svg",
          color : "bckRed"
      })
  }, [])
  return (
    <div id="bilanCompetence" className='page'>
      	<img src="/bc.png" alt="" />
		  <Link to={"/accueil/drhf/fiche_contact"}
				className='cadreClique'
				onClick={() => {
                    setCrumbs([
						{
							page :'/accueil',
							title : "Accueil"
						},
						{
							page : "/accueil/drhf",
							title : "Ma DRHF"
						},
						{
							page : "/accueil/drhf/fiche_contact",
							title : "Fiche contact"
						},
					])                       
                }} 
			></Link>
    </div>
  )
}
